module.exports = __webpack_public_path__ + "img/close-button.e0e3e670.svg";